/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import type {
  BadRequestResponse,
  ForbiddenResponse,
  InternalServerErrorResponse,
  TermsAndConditionsConsentDTO,
  UnauthorizedResponse,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Sets the terms and conditions consent
 * @summary Sets the terms and conditions consent
 */
export type setTermsAndConditionsConsentResponse = {
  data: void;
  status: number;
};

export const getSetTermsAndConditionsConsentUrl = () => {
  return `http://localhost:8080/platform/v1/users/terms-and-conditions`;
};

export const setTermsAndConditionsConsent = async (
  termsAndConditionsConsentDTO: TermsAndConditionsConsentDTO,
  options?: RequestInit
): Promise<setTermsAndConditionsConsentResponse> => {
  return customFetchInstance<Promise<setTermsAndConditionsConsentResponse>>(
    getSetTermsAndConditionsConsentUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(termsAndConditionsConsentDTO),
    }
  );
};

export const getSetTermsAndConditionsConsentMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setTermsAndConditionsConsent>>,
    TError,
    { data: TermsAndConditionsConsentDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setTermsAndConditionsConsent>>,
  TError,
  { data: TermsAndConditionsConsentDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setTermsAndConditionsConsent>>,
    { data: TermsAndConditionsConsentDTO }
  > = (props) => {
    const { data } = props ?? {};

    return setTermsAndConditionsConsent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetTermsAndConditionsConsentMutationResult = NonNullable<
  Awaited<ReturnType<typeof setTermsAndConditionsConsent>>
>;
export type SetTermsAndConditionsConsentMutationBody =
  TermsAndConditionsConsentDTO;
export type SetTermsAndConditionsConsentMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Sets the terms and conditions consent
 */
export const useSetTermsAndConditionsConsent = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setTermsAndConditionsConsent>>,
    TError,
    { data: TermsAndConditionsConsentDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setTermsAndConditionsConsent>>,
  TError,
  { data: TermsAndConditionsConsentDTO },
  TContext
> => {
  const mutationOptions =
    getSetTermsAndConditionsConsentMutationOptions(options);

  return useMutation(mutationOptions);
};
